import React, { Fragment, useRef, useState } from 'react';
import { HomeOutline, ChevronLeftFill, MoreHorizontalOutline } from '@olist/design-system-icons';
import { BreadcrumbContainer, BreadcrumbItem, StyledButtonIcon, StyledChevronRightOutline } from './styles.js';
import useIsLowerResolution from '../../hooks/useIsLowerResolution.js';
import DropdownNamespace from '../Dropdown/Dropdown.js';
import Link from '../Link/Link.js';
import '../Text/Caption/Caption.js';
import '../Text/DetailedSubheading/DetailedSubheading.js';
import '../Text/OverlineLg/OverlineLg.js';
import '../Text/OverlineMd/OverlineMd.js';
import '../Text/ParagraphLg/ParagraphLg.js';
import ParagraphMd from '../Text/ParagraphMd/ParagraphMd.js';
import '../Text/SectionHeading/SectionHeading.js';
import '../Text/SectionSubheading/SectionSubheading.js';
import '../Text/Title/Title.js';

const Contraction = ({ items, contractionButtonAriaLabel, }) => {
    const dropdownRef = useRef(null);
    const [isOpenDrodpdown, setIsOpenDrodpdown] = useState(false);
    const handleDropdownClose = () => setIsOpenDrodpdown(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledButtonIcon, { ref: dropdownRef, icon: React.createElement(MoreHorizontalOutline, { "aria-hidden": true }), "aria-haspopup": "true", "aria-label": contractionButtonAriaLabel, onClick: () => setIsOpenDrodpdown(!isOpenDrodpdown) }),
        React.createElement(DropdownNamespace, { anchorElement: dropdownRef, isOpen: isOpenDrodpdown, onClose: handleDropdownClose }, items.map((item, index) => (React.createElement(DropdownNamespace.Item, { key: index, href: item.link, onClick: item.onClick
                ? (e) => {
                    var _a;
                    e.preventDefault();
                    (_a = item.onClick) === null || _a === void 0 ? void 0 : _a.call(item);
                }
                : undefined }, item.text))))));
};
const DEFAULT_ROOT_LINK = { link: '/', text: 'home' };
const Breadcrumb = ({ items: baseItems, rootElement = DEFAULT_ROOT_LINK, contractionButtonAriaLabel = 'menu reduzido', }) => {
    const isLowerResolution = useIsLowerResolution();
    const INDEX_TO_START_CONTRACTION = 1;
    const MAX_ITEMS = 3;
    const items = baseItems.slice();
    const showContraction = baseItems.length > MAX_ITEMS;
    const lastLinkItem = items[items.length - 2];
    const contractionItems = showContraction
        ? items.splice(INDEX_TO_START_CONTRACTION, baseItems.length - 2)
        : [];
    const isLastItem = (index) => index === items.length - 1;
    return (React.createElement(BreadcrumbContainer, null, !isLowerResolution ? (React.createElement(React.Fragment, null,
        React.createElement(BreadcrumbItem, null,
            React.createElement(StyledButtonIcon, { forwardedAs: "a", href: rootElement.link, "aria-label": rootElement.text, icon: React.createElement(HomeOutline, { "aria-hidden": true }), onClick: rootElement.onClick
                    ? (e) => {
                        var _a;
                        e.preventDefault();
                        (_a = rootElement.onClick) === null || _a === void 0 ? void 0 : _a.call(rootElement);
                    }
                    : undefined }),
            React.createElement(StyledChevronRightOutline, { "aria-hidden": true })),
        items.map((item, index) => (React.createElement(Fragment, { key: index },
            item.link && index <= INDEX_TO_START_CONTRACTION && (React.createElement(BreadcrumbItem, null,
                React.createElement(Link, { href: item.link, onClick: item.onClick
                        ? (e) => {
                            var _a;
                            e.preventDefault();
                            (_a = item.onClick) === null || _a === void 0 ? void 0 : _a.call(item);
                        }
                        : undefined }, item.text),
                React.createElement(StyledChevronRightOutline, { "aria-hidden": true }))),
            showContraction && index === INDEX_TO_START_CONTRACTION && (React.createElement(BreadcrumbItem, null,
                React.createElement(Contraction, { items: contractionItems, contractionButtonAriaLabel: contractionButtonAriaLabel }),
                React.createElement(StyledChevronRightOutline, { "aria-hidden": true }))),
            isLastItem(index) && (React.createElement(BreadcrumbItem, null,
                React.createElement(ParagraphMd, { type: "default", c: "neutral.base" }, item.text)))))))) : lastLinkItem ? (React.createElement(BreadcrumbItem, null,
        React.createElement(Link, { iconLeft: React.createElement(ChevronLeftFill, null), href: lastLinkItem.link, onClick: lastLinkItem.onClick
                ? (e) => {
                    var _a;
                    e.preventDefault();
                    (_a = lastLinkItem.onClick) === null || _a === void 0 ? void 0 : _a.call(lastLinkItem);
                }
                : undefined }, lastLinkItem.text))) : (React.createElement("div", null,
        React.createElement(ChevronLeftFill, { "aria-hidden": true }),
        React.createElement(StyledButtonIcon, { forwardedAs: "a", href: rootElement.link, "aria-label": rootElement.text, icon: React.createElement(HomeOutline, { "aria-hidden": true }) })))));
};

export { Breadcrumb as default };
